/**
 * Story 107.4 — tiny build identifier in the AppShell footer.
 * Lets support ask "what does the corner say?" and pinpoint stale
 * clients in seconds. The tooltip carries the full ISO build time;
 * the visible label is the 7-char git SHA.
 */
export function BuildInfo() {
  const sha = __APP_VERSION__;
  const builtAt = __APP_BUILT_AT__;
  const formatted = (() => {
    try {
      return new Date(builtAt).toLocaleString();
    } catch {
      return builtAt;
    }
  })();
  return (
    <span
      title={`Built at ${formatted}`}
      className="select-all text-[10px] font-mono text-muted-foreground/60 hover:text-muted-foreground"
    >
      v:{sha}
    </span>
  );
}
